<template>
  <transition name="layer">
    <div class="exchange_detail_layer" v-if="exchangeDetail != -1">
      <div class="layer_deco">
        <div class="layer">
          <div class="layer-header">
            <h1>상세내역</h1>
          </div>
          <perfect-scrollbar class="layer_scroll">
            <div v-if="exchangeDetailCnts.userType === 1" class="contents individual">
              <dl>
                <dt>신청일자</dt>
                <dd>{{ exchangeDetailCnts.regDate }}</dd>
              </dl>
              <dl>
                <dt>신청 포인트</dt>
                <dd>
                  {{ pointInfo.pointName }}
                  {{ addComma(exchangeDetailCnts.exchangePoint) }}
                  {{ pointInfo.pointUnitName }}
                </dd>
              </dl>
              <dl>
                <dt>계좌 정보</dt>
                <dd>계좌주 : {{ exchangeDetailCnts.accountOwnerName }}</dd>
                <dd class="account" :class="{ account_modify: exchangeDetailCnts.exchangeStatus === 1 }">
                  <span class="account">
                    {{ exchangeDetailCnts.bankName }}
                    {{ exchangeDetailCnts.accountNo }}
                  </span>
                  <v-button @handleClick="handleClick()" class="btn07" text="계좌번호 수정" />
                </dd>
              </dl>
              <dl>
                <dt>처리 상태</dt>
                <dd :class="stateClass(exchangeDetailCnts.exchangeStatus)">
                  {{ exchangeDetailCnts.exchangeStatusName }}
                  <span class="msg" v-if="exchangeDetailCnts.exchangeStatus === 6 && exchangeDetailCnts.reason"
                    >({{ exchangeDetailCnts.reason }})</span
                  >
                </dd>
              </dl>
              <dl>
                <dt>지급일</dt>
                <dd v-if="exchangeDetailCnts.exchangeStatus === 5">{{ exchangeDetailCnts.paymentDate }}</dd>
                <dd v-else>-</dd>
              </dl>
              <dl>
                <dt>최종 지급 금액</dt>
                <dd class="result">{{ addComma(exchangeDetailCnts.finalAmount) }} 원</dd>
                <dd>
                  <dl>
                    <dt>신청 금액</dt>
                    <dd>{{ addComma(exchangeDetailCnts.requestAmount) }} 원</dd>
                  </dl>
                  <dl>
                    <dt>수수료</dt>
                    <dd>
                      <span class="red">{{ amountTrans(exchangeDetailCnts.feeAmount) }}</span> 원
                    </dd>
                  </dl>
                  <dl>
                    <dt>세금</dt>
                    <dd>
                      <span class="red">{{ amountTrans(exchangeDetailCnts.taxAmount) }}</span> 원
                    </dd>
                  </dl>
                  <dl>
                    <dt>실 지급액</dt>
                    <dd>{{ addComma(exchangeDetailCnts.actualAmount) }} 원</dd>
                  </dl>
                </dd>
              </dl>
            </div>

            <div v-else class="contents business">
              <dl>
                <dt>적립 금액</dt>
                <dd>
                  <dl>
                    <dt>포인트 종류</dt>
                    <dd>{{ exchangeDetailCnts.liabilityType }}</dd>
                  </dl>
                  <dl>
                    <dt>적립 기간</dt>
                    <dd>{{ exchangeDetailCnts.savePeriod }}</dd>
                  </dl>
                  <dl>
                    <dt>포인트</dt>
                    <dd>{{ addComma(exchangeDetailCnts.exchangePoint) }}{{ pointInfo.pointUnitName }}</dd>
                  </dl>
                  <dl>
                    <dt>전환 비율</dt>
                    <dd>{{ exchangeDetailCnts.rate }}</dd>
                  </dl>
                  <dl>
                    <dt>수익 금액</dt>
                    <dd>{{ addComma(exchangeDetailCnts.requestAmount) }} 원</dd>
                  </dl>
                  <dl>
                    <dt>진행 상태</dt>
                    <dd :class="stateClass(exchangeDetailCnts.exchangeStatus)">
                      {{ exchangeDetailCnts.exchangeStatusName }}
                      <span class="msg" v-if="exchangeDetailCnts.exchangeStatus === 6 && exchangeDetailCnts.reason"
                        >({{ exchangeDetailCnts.reason }})</span
                      >
                    </dd>
                  </dl>
                </dd>
              </dl>
              <dl>
                <dt>수익 지급 상세 내용</dt>
                <dd>
                  <dl>
                    <dt>공급가액</dt>
                    <dd>
                      <strong>{{ addComma(exchangeDetailCnts.requestAmount) }}원</strong>
                    </dd>
                  </dl>
                  <dl>
                    <dt>부가세</dt>
                    <dd>
                      <strong>{{ addComma(exchangeDetailCnts.taxAmount) }}원</strong>
                    </dd>
                  </dl>
                  <dl>
                    <dt>세금 계산서 발행일</dt>
                    <dd>{{ exchangeDetailCnts.taxInvoiceDate }}</dd>
                  </dl>
                  <dl>
                    <dt>서류 제출일</dt>
                    <dd style="color: #d83d3f">{{ exchangeDetailCnts.taxInvoiceDeadline }} 까지</dd>
                  </dl>
                  <dl>
                    <dt>지급 예정일</dt>
                    <dd>{{ exchangeDetailCnts.paymentDate }}</dd>
                  </dl>
                  <dl>
                    <dt>업체명</dt>
                    <dd>{{ exchangeDetailCnts.businessName }}</dd>
                  </dl>
                  <dl>
                    <dt>지급 은행 계좌</dt>
                    <dd>{{ exchangeDetailCnts.bankName }} {{ exchangeDetailCnts.accountNo }}</dd>
                  </dl>
                </dd>
              </dl>
              <ul>
                <li>
                  서류제출일까지 전자세금계산서를
                  <a href="mailto:rewardpoint_tax@nexon.co.kr">rewardpoint_tax@nexon.co.kr</a>로 보내주세요.
                </li>
                <li>세금계산서 미발행하신 경우 수익지급이 취소되거나 포인트가 소멸될 수 있습니다.</li>
              </ul>
            </div>
          </perfect-scrollbar>
          <div class="bt">
            <v-button @handleClick="setExchangeDetail(-1)" class="btn_close2" :textHide="true" text="닫기" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import mixin from '@/utils/mixin';
import { mapActions, mapGetters } from 'vuex';
import VButton from '@/components/atoms/VButton';
import sendLog from '@/utils/analistic';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import { EXCHANGE_STATUS_CLASS } from '@/consts/consts';

export default {
  mixins: [mixin],
  components: {
    PerfectScrollbar,
    VButton,
  },
  computed: {
    ...mapGetters(['serviceUrl']),
    ...mapGetters('point', ['pointInfo']),
    ...mapGetters('exchange', ['exchangeList', 'exchangeDetail']),
    exchangeDetailCnts() {
      return this.exchangeList.list[this.exchangeDetail];
      // return _.find(this.exchangeList.list, {'exchangeNo': this.exchangeDetail} );
    },
  },
  methods: {
    ...mapActions('exchange', ['setExchangeDetail', 'setExchangeDetailAccount', 'setBankSelect', 'setAccountNo']),
    amountTrans(val) {
      if (val === 0) {
        return 0;
      } else {
        return `-${this.addComma(val)}`;
      }
    },
    handleClick() {
      this.setExchangeDetailAccount(true);
      this.setBankSelect(null);
      this.setAccountNo('');
    },
    stateClass(val) {
      return EXCHANGE_STATUS_CLASS.PLUS.includes(val)
        ? 'blue'
        : EXCHANGE_STATUS_CLASS.MINUS.includes(val)
        ? 'red'
        : 'gray';
    },
  },
  updated() {
    if (this.exchangeDetail !== -1) {
      sendLog('exchangeHistory_detail', JSON.parse(`{"servicename":"${this.serviceUrl}"}`), 'contents');
    }
  },
};
</script>

iOS 수직정렬 대응하여 임시로 별도 처리함. 레이어 수직정렬 전반적으로 개편 필요
<style scoped lang="scss">
.exchange_detail_layer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  .layer {
    width: 100vw;
  }
}
</style>

<style lang="scss">
.red {
  color: #d83d3f;
}
strong {
  font-weight: bold;
}
.business {
  dd.blue {
    color: #0f1f9a;
  }
  dd.red {
    color: #d83d3f;
  }
  dd.gray {
    color: #999;
  }
}
</style>
